import React from 'react'
import { useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import { seenPatientType } from 'src/services/analytics'
import { useIsCityVariant } from '@hooks/useIsCityVariant'
import useWizardManager from '@hooks/useWizardManager'
import PatientScreen from '@screens/Patient/PatientScreen'
import { usePainDetailsContext } from '@context/PainDetailsContext'
import { useIsAllClinicsVariant } from '@hooks/useIsAllClinicsVariant'

const Patient = () => {
  useWizardManager({
    targetRoute: routes.patient,
    onValidStep: () => seenPatientType(),
  })
  const history = useHistory()
  const isCityVariant = useIsCityVariant()
  const isAllClinicsVariant = useIsAllClinicsVariant()
  const { showPainTreatmentForm } = usePainDetailsContext()

  const handleBackClicked = () => {
    const redirectTo = (() => {
      if (showPainTreatmentForm) return routes.painDetails
      if (isCityVariant || isAllClinicsVariant) return routes.clinic

      return routes.upsell
    })()

    history.push(redirectTo)
  }

  return <PatientScreen onBackClicked={handleBackClicked} />
}

export default Patient
